<script>
export default {
  inheritAttrs: false,

  props: {
    decisions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    listeners () {
      const {
        save,
        ...listeners
      } = this.$listeners;

      return listeners;
    },
  },

  methods: {
    handleInput (key) {
      const selected = this.decisions.find((decision) => decision.key === key);

      if (! selected) {
        return;
      }

      this.$emit('save', {
        key,
        ...selected,
      });
    },
  },
};
</script>

<template>
  <AutomationBuilderModal
    v-bind="$attrs"
    v-on="listeners"
    :items="decisions"
    @input="handleInput"
    :title="__('Escolha a decisão')"
    :button="__('Escolher decisão')"
  />
</template>
